import React, { useState } from "react";
import { Link } from "react-router-dom";

const Header = ({ isFixed }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleNavbar = () => {
    setIsExpanded(!isExpanded);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  return (
    <header className={isFixed ? "fix_style fixed" : ""}>
      <div className="container">
        <nav className="navbar navbar-expand-lg">
          <Link className="navbar-brand" to="/">
            <div className="logo-container">
              <img
                src="/assets/images/header/mainLogo.png"
                alt="Logo Woven Mina"
                className="header-logo-top"
              />
              
            </div>
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleNavbar}
            aria-controls="navbarSupportedContent"
            aria-expanded={isExpanded}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon">
              <span className={`toggle-wrap ${isExpanded ? "active" : ""}`}>
                <span className="toggle-bar" />
              </span>
            </span>
          </button>
          <div
            className={`collapse navbar-collapse ${isExpanded ? "show" : ""}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav mx-auto">
              {" "}
              <li className="nav-item">
                <Link className="nav-link" to="/">
                  Home
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/logo">
                  Galeri Logo
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/jasa">
                  Jasa
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/contact">
                  Kontak Kami
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
